(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var menuToggle = document.querySelector('[data-menu-toggle]');
    var navLinks = document.getElementById('site-nav-links');
    if (menuToggle && navLinks) {
      menuToggle.addEventListener('click', function () {
        var isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
        menuToggle.setAttribute('aria-expanded', String(!isOpen));
        navLinks.classList.toggle('is-open', !isOpen);
        menuToggle.setAttribute('aria-label',
          !isOpen
            ? menuToggle.getAttribute('data-label-close')
            : menuToggle.getAttribute('data-label-open')
        );
      });

      document.addEventListener('click', function (e) {
        if (!e.target.closest('.site-header') && navLinks.classList.contains('is-open')) {
          navLinks.classList.remove('is-open');
          menuToggle.setAttribute('aria-expanded', 'false');
          menuToggle.setAttribute('aria-label', menuToggle.getAttribute('data-label-open'));
        }
      });
    }
  })();

  (function () {
    var items = document.querySelectorAll('[data-mega-item]');

    items.forEach(function (item) {
      var toggle = item.querySelector('[data-mega-toggle]');
      var mega = item.querySelector('.site-header__mega');
      if (!toggle || !mega) return;

      var hideTimer;

      function showMega() {
        clearTimeout(hideTimer);
        // Offset the absolutely-positioned panel so it spans the viewport
        // regardless of where this nav item sits horizontally.
        var navLeft = item.getBoundingClientRect().left;
        mega.style.left = -navLeft + 'px';
        mega.style.display = 'block';
        toggle.setAttribute('aria-expanded', 'true');
        mega.setAttribute('aria-hidden', 'false');
        var svg = toggle.querySelector('svg');
        if (svg) svg.style.transform = 'rotate(180deg)';
      }

      function hideMega() {
        hideTimer = setTimeout(function () {
          // Don't close while a keyboard user still has focus inside.
          if (item.contains(document.activeElement)) return;
          mega.style.display = '';
          toggle.setAttribute('aria-expanded', 'false');
          mega.setAttribute('aria-hidden', 'true');
          var svg = toggle.querySelector('svg');
          if (svg) svg.style.transform = '';
        }, 150);
      }

      // Desktop: hover with delay on hide to bridge the gap
      item.addEventListener('mouseenter', function () {
        if (window.matchMedia('(min-width: 801px)').matches) showMega();
      });
      item.addEventListener('mouseleave', function () {
        if (window.matchMedia('(min-width: 801px)').matches) hideMega();
      });

      // Desktop keyboard: open when focus enters the item, close when it leaves
      item.addEventListener('focusin', function () {
        if (window.matchMedia('(min-width: 801px)').matches) showMega();
      });
      item.addEventListener('focusout', function (e) {
        if (
          window.matchMedia('(min-width: 801px)').matches &&
          !item.contains(e.relatedTarget)
        ) {
          hideMega();
        }
      });

      // Toggle button: works with mouse, Enter and Space, on every viewport
      toggle.addEventListener('click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        if (window.matchMedia('(max-width: 800px)').matches) {
          toggle.setAttribute('aria-expanded', String(!isOpen));
          mega.classList.toggle('is-open', !isOpen);
          mega.setAttribute('aria-hidden', String(isOpen));
        } else if (isOpen) {
          clearTimeout(hideTimer);
          mega.style.display = '';
          toggle.setAttribute('aria-expanded', 'false');
          mega.setAttribute('aria-hidden', 'true');
          var svg = toggle.querySelector('svg');
          if (svg) svg.style.transform = '';
        } else {
          showMega();
        }
      });

      // Escape closes the panel and returns focus to the toggle
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
          clearTimeout(hideTimer);
          mega.style.display = '';
          mega.classList.remove('is-open');
          mega.setAttribute('aria-hidden', 'true');
          toggle.setAttribute('aria-expanded', 'false');
          var svg = toggle.querySelector('svg');
          if (svg) svg.style.transform = '';
          toggle.focus();
        }
      });
    });

    function closeAll() {
      items.forEach(function (item) {
        var toggle = item.querySelector('[data-mega-toggle]');
        var mega = item.querySelector('.site-header__mega');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        if (mega) {
          mega.style.display = '';
          mega.classList.remove('is-open');
          mega.setAttribute('aria-hidden', 'true');
          var svg = toggle.querySelector('svg');
          if (svg) svg.style.transform = '';
        }
      });
    }

    // Close on outside click
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-mega-item]')) closeAll();
    });

    // Recompute the horizontal offset on resize so open panels keep spanning
    // the viewport. Vertical tracking is now pure CSS (absolute positioning).
    window.addEventListener('resize', function () {
      if (!window.matchMedia('(min-width: 801px)').matches) return;
      items.forEach(function (item) {
        var mega = item.querySelector('.site-header__mega');
        if (mega && mega.style.display === 'block') {
          mega.style.left = -item.getBoundingClientRect().left + 'px';
        }
      });
    });
  })();

  // ── Predictive search ────────────────────────────────────────────────
  (function () {
    var form = document.querySelector('[data-predictive-search]');
    if (!form) return;
    var input = form.querySelector('[data-predictive-input]');
    var results = form.querySelector('[data-predictive-results]');
    if (!input || !results) return;

    var MIN_LEN = 2;
    var DEBOUNCE_MS = 180;
    var debounceTimer;
    var lastQuery = '';
    var currentController;

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
      });
    }

    function openResults() {
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
    function closeResults() {
      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }

    function renderLoading() {
      results.innerHTML = '<p class="site-header__predictive-loading">…</p>';
      openResults();
    }

    function renderEmpty(q) {
      results.innerHTML =
        '<p class="site-header__predictive-empty">' +
        'Ei ehdotuksia haulle “' + escapeHtml(q) + '”' +
        '</p>';
      openResults();
    }

    function groupHtml(title, items, renderItem) {
      if (!items || !items.length) return '';
      var inner = items.map(renderItem).join('');
      return (
        '<div class="site-header__predictive-group">' +
          '<p class="site-header__predictive-title">' + escapeHtml(title) + '</p>' +
          inner +
        '</div>'
      );
    }

    function productItem(p) {
      var img = p.featured_image && p.featured_image.url
        ? '<div class="site-header__predictive-thumb"><img src="' + p.featured_image.url + '" alt="" loading="lazy"></div>'
        : '<div class="site-header__predictive-thumb"></div>';
      var price = p.price ? '<span class="site-header__predictive-meta">' + escapeHtml(p.price) + '</span>' : '';
      return (
        '<a class="site-header__predictive-item" href="' + p.url + '" role="option">' +
          img +
          '<span class="site-header__predictive-text">' +
            '<span class="site-header__predictive-name">' + escapeHtml(p.title) + '</span>' +
            price +
          '</span>' +
        '</a>'
      );
    }

    function plainItem(it) {
      return (
        '<a class="site-header__predictive-item" href="' + it.url + '" role="option">' +
          '<span class="site-header__predictive-text">' +
            '<span class="site-header__predictive-name">' + escapeHtml(it.title) + '</span>' +
          '</span>' +
        '</a>'
      );
    }

    function renderResults(q, data) {
      var r = (data && data.resources && data.resources.results) || {};
      var products = r.products || [];
      var articles = r.articles || [];
      var pages = r.pages || [];

      if (!products.length && !articles.length && !pages.length) {
        renderEmpty(q);
        return;
      }

      var html =
        groupHtml('Tuotteet', products, productItem) +
        groupHtml('Artikkelit', articles, plainItem) +
        groupHtml('Sivut', pages, plainItem);

      var searchUrl = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root.replace(/\/$/, '') : '') + '/search?q=' + encodeURIComponent(q);
      html += '<a class="site-header__predictive-all" href="' + searchUrl + '">Näytä kaikki tulokset →</a>';

      results.innerHTML = html;
      openResults();
    }

    function fetchResults(q) {
      if (currentController) currentController.abort();
      currentController = new AbortController();
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,article,page' +
        '&resources[limit]=6&resources[limit_scope]=each';
      return fetch(url, { signal: currentController.signal })
        .then(function (r) { return r.json(); });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(debounceTimer);
      if (q.length < MIN_LEN) {
        closeResults();
        return;
      }
      if (q === lastQuery) return;
      lastQuery = q;
      renderLoading();
      debounceTimer = setTimeout(function () {
        fetchResults(q)
          .then(function (data) { renderResults(q, data); })
          .catch(function (err) { if (err.name !== 'AbortError') closeResults(); });
      }, DEBOUNCE_MS);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MIN_LEN && results.innerHTML) openResults();
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) closeResults();
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeResults();
        input.blur();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.page__content table').forEach(function (table) {
      var headerCells = table.querySelectorAll('thead th');
      var headers, headerRow;

      if (headerCells.length) {
        headers = Array.from(headerCells).map(function (th) { return th.textContent.trim(); });
      } else {
        headerRow = table.querySelector('tbody tr');
        if (!headerRow) return;
        headers = Array.from(headerRow.querySelectorAll('th, td')).map(function (cell) {
          return cell.textContent.trim();
        });
        headerRow.classList.add('table-header-row');
      }

      if (!headers.length) return;

      table.querySelectorAll('tbody tr').forEach(function (row) {
        if (row === headerRow) return;
        Array.from(row.querySelectorAll('td')).forEach(function (td, i) {
          if (headers[i]) td.setAttribute('data-label', headers[i]);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
